import type { ConnectionStatus } from '@kontor/shared'

/**
 * Verbindungszustände in Wort und Farbe — an einer Stelle, weil sie an mehreren erscheinen:
 * Serverkarte, Seitenleiste, Lagebild. Zwei Listen, die auseinanderlaufen, ergeben zwei
 * Wahrheiten über denselben Server.
 */
export const STATUS_LABELS: Record<ConnectionStatus, string> = {
  disconnected: 'Getrennt',
  connecting: 'Verbindet …',
  connected: 'Verbunden',
  degraded: 'Gestört',
  unreachable: 'Nicht erreichbar',
}

export const STATUS_DOT: Record<ConnectionStatus, string> = {
  disconnected: 'bg-muted-foreground/40',
  connecting: 'bg-status-warn animate-pulse',
  connected: 'bg-status-ok',
  degraded: 'bg-status-warn',
  unreachable: 'bg-destructive',
}
